import Vue from 'vue'
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'

import './plugins/pollyfills'
import App from './App.vue'

// Plugins
import Dashboard from './plugins/dashboardPlugin';
import PermissionsPlugin from './plugins/permissionsPlugin';
import authMiddleware from 'src/middleware/authMiddleware';
import initProgress from './progressbar';

import router from './routes/router'
import store from './store'
import i18n from './i18n'
import './services/apiConfig';
import { setLocaleHeader } from 'src/services/apiConfig'

initProgress(router);
Vue.use(Dashboard);
Vue.use(PermissionsPlugin, store);
authMiddleware(router, store);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
setLocaleHeader(store.state.config.textLanguage || 'en')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  i18n,
  router
});
